class NikitaProduct extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.querySelector('form.nikita-product-form');
    this.atcBtn = this.productForm.querySelector('button[type="submit"]');
    this.stickyAtcBtn = this.querySelector('button#sticky-AddToCart');
    this.soldOut = false;
    this.v_id = this.productForm.querySelector('select').value;

    this.playButton = this.querySelector('[data-gallery-video-control]')
    if (this.playButton) this.playButton.addEventListener('click', this.playVideo.bind(this))

    this.video = this.querySelector('[data-gallery-video] video')
    if (this.video) {
      this.video.addEventListener('click', this.pauseVideo.bind(this))
      this.initVideoObserver();
    } 

    this.thumbSwiper = new Swiper(this.querySelector('.thumbslider .swiper'), {
      slidesPerView: 6,
      spaceBetween: 8,
      loop: true,
      navigation: {
        nextEl: this.querySelector(".thumbslider .button-next"),
        prevEl: this.querySelector(".thumbslider .button-prev"),
      },
      breakpoints: {
        1025: {
          direction: "vertical",
          slidesPerView: 4,
          spaceBetween: 15,
        },
      }
    });

    let direction = '';
    window.innerWidth > 1024 ? direction = 'vertical' : direction = 'horizontal';
    this.thumbSwiper.changeDirection(direction);

    this.mediaSlider = new Swiper(this.querySelector('.mainslider .swiper'), {
      spaceBetween: 10,
      loop: true,
      cssMode: window.navigator.platform === 'iPhone',
      zoom: {
        maxRatio: 1.5,
        minRatio: 1
      },
      thumbs: {
        swiper: this.thumbSwiper,
      }
    });
    
    this.addAction();
    this.syncInitialPurchaseState();
    this.watchKlaviyoNotifyButton();
  }

  watchKlaviyoNotifyButton() {
    if (!this.productForm || this.closest('#quick_view_modal')) {
      return;
    }

    const syncFromState = () => {
      const productOptions = this.querySelector('product-options');
      if (!productOptions) {
        return;
      }

      this.syncKlaviyoBackInStock(
        productOptions.dataset.availability === 'true',
        productOptions.dataset.v_id,
      );
    };

    this.klaviyoNotifyObserver = new MutationObserver(syncFromState);
    this.klaviyoNotifyObserver.observe(this.productForm, {
      childList: true,
      subtree: true,
    });
  }

  disconnectedCallback() {
    if (this.klaviyoNotifyObserver) {
      this.klaviyoNotifyObserver.disconnect();
    }
  }

  syncInitialPurchaseState() {
    const productOptions = this.querySelector('product-options');
    if (!productOptions) {
      return;
    }

    const isAvailable = productOptions.dataset.availability === 'true';
    this.setPurchaseAvailability(
      isAvailable,
      productOptions.dataset.v_id,
    );
  }

  setPurchaseAvailability(isAvailable, variantId = null) {
    this.soldOut = !isAvailable;

    if (this.atcBtn) {
      this.atcBtn.classList.toggle('available-sold', isAvailable);
    }

    if (this.stickyAtcBtn) {
      this.stickyAtcBtn.classList.toggle('available-sold', isAvailable);
      const stickyWrapper = this.stickyAtcBtn.closest('.sticky-atc-wrapper');
      if (stickyWrapper) {
        stickyWrapper.classList.toggle('variant-unavailable', !isAvailable);
      }
    }

    const resolvedVariantId =
      variantId ||
      this.v_id ||
      this.productForm?.querySelector('product-options')?.dataset?.v_id;

    if (!this.closest('#quick_view_modal')) {
      this.syncKlaviyoBackInStock(isAvailable, resolvedVariantId);

      if (!isAvailable) {
        this.reorderOosCtaButtons();
      }
    }
  }

  reorderOosCtaButtons() {
    const ctasHolder = this.productForm?.querySelector('.ctas_holder');
    if (!ctasHolder) {
      return;
    }

    const notifyButton = ctasHolder.querySelector(
      '.notifyButtonStyle, .klaviyo-bis-trigger, [data-klaviyo-bis-trigger], .restock-alerts-notify-button',
    );
    const wishlistButton = ctasHolder.querySelector(
      '.nm-wishlist-button, [class*="wishlist-button"]',
    );

    if (!notifyButton || !wishlistButton) {
      return;
    }

    const notifyNode = notifyButton.closest('.nm-portal') || notifyButton;
    const wishlistNode = wishlistButton.closest('.nm-portal') || wishlistButton;

    if (
      notifyNode !== wishlistNode &&
      wishlistNode.parentNode === ctasHolder &&
      (notifyNode.compareDocumentPosition(wishlistNode) &
        Node.DOCUMENT_POSITION_PRECEDING)
    ) {
      ctasHolder.insertBefore(notifyNode, wishlistNode);
    }
  }

  syncKlaviyoBackInStock(isAvailable, variantId) {
    if (!this.productForm || this.closest('#quick_view_modal')) {
      return;
    }

    const variantSelect = this.productForm.querySelector('select[name="id"]');
    if (variantSelect && variantId) {
      const nextValue = String(variantId);
      if (variantSelect.value !== nextValue) {
        variantSelect.value = nextValue;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (!variantId) {
      return;
    }

    const notifyButtons = this.productForm.querySelectorAll(
      '.notifyButtonStyle, .klaviyo-bis-trigger, [data-klaviyo-bis-trigger], .restock-alerts-notify-button',
    );

    notifyButtons.forEach((button) => {
      button.dataset.variantId = variantId;
      button.hidden = isAvailable;
      button.style.display = isAvailable ? 'none' : '';
      button.setAttribute('aria-hidden', isAvailable ? 'true' : 'false');
    });

    if (!isAvailable) {
      this.reorderOosCtaButtons();
    }
  }

  addAction() {
    this.mediaSlider.on("slideChangeTransitionStart", this.mediaSlider.zoom.out);

    window.addEventListener('resize', () => {
      if(window.innerWidth <= 1024) {
        this.thumbSwiper.changeDirection('horizontal');
      } else this.thumbSwiper.changeDirection('vertical');
      if(window.innerWidth == 1024) this.thumbSwiper.changeDirection('horizontal');
    });

    this.mediaSlider.on('click', this.mediaSlider.zoom.in);

    this.addEventListener('variant:change', (ev) => {
      const isAvailable = ev.target.dataset.availability === 'true';
      const variantId = ev.target.dataset.v_id;
      this.setPurchaseAvailability(isAvailable, variantId);

      if (!variantId) {
        return;
      }

      this.v_id = variantId;
      let m_id = ev.target.dataset.m_id;
      this.v_price = ev.target.dataset.v_price;
      let slided = false;
      const slider = this.mediaSlider;
      this.querySelectorAll('.mainslider .swiper-slide .img-wrapper').forEach((img, arg) => {
        if(img.dataset.id == m_id && !slided) {
          slided = true;
          slider.slideTo(arg) ;
        }
      });

      const bundlePriceContainer = document.querySelector('[data-bundle-price]')
      
      if (bundlePriceContainer) {
        const symbol = bundlePriceContainer.getAttribute('data-bundle-price')
        const dataPrice = parseFloat(this.v_price.replace(/[^\d.]/g, '')); 
        const percentPrice = dataPrice * 0.2; 
        const discount = dataPrice - percentPrice;
        const totalBundlePrice = discount.toFixed(2)

        document.querySelector('.product_price').innerHTML = `${symbol}${totalBundlePrice}` 
        document.querySelector('.product_compare_price').innerHTML = `${this.v_price}`
        if (this.atcBtn) {
          const addToCartPrice = this.atcBtn.querySelector('#AddToCartPrice');
          if (addToCartPrice) addToCartPrice.innerHTML = `${symbol}${totalBundlePrice}`;
        }
        if (this.stickyAtcBtn) {
          const stickyAddToCartPrice = this.stickyAtcBtn.querySelector('#AddToCartPrice');
          if (stickyAddToCartPrice) stickyAddToCartPrice.innerHTML = `${symbol}${totalBundlePrice}`;
        } 
        
      } else {
        document.querySelector('.product_price').innerHTML = this.v_price;
        if (this.atcBtn) {
          const addToCartPrice = this.atcBtn.querySelector('#AddToCartPrice');
          if (addToCartPrice) addToCartPrice.innerHTML = this.v_price;
        }
        if (this.stickyAtcBtn) {
          const stickyAddToCartPrice = this.stickyAtcBtn.querySelector('#AddToCartPrice');
          if (stickyAddToCartPrice) stickyAddToCartPrice.innerHTML = this.v_price;
        }
      }
    });

    this.addEventListener('product:soldout', () => {
      this.setPurchaseAvailability(false);
    });

    this.productForm.addEventListener('submit', (ev) => {
      ev.preventDefault();
      this.addToCart(this.soldOut);
    });

    this.atcBtn.addEventListener('click', (ev) => {
      ev.preventDefault();
      this.addToCart(this.soldOut);
    });

    if (this.stickyAtcBtn) {
      this.stickyAtcBtn.addEventListener('click', (ev) => {
        ev.preventDefault();
        this.addToCart(this.soldOut);
      });
    }
    document.addEventListener('scroll', () => {
      if (!this.atcBtn) {
        return;
      }
      const {top, height} = this.atcBtn.getBoundingClientRect();
      this.stickyShow(top + height < 0);
    });
  }

  addToCart(soldOut=false) {
    if (
      soldOut ||
      !this.productForm ||
      this.productForm.classList.contains('variant-unavailable') ||
      this.productForm.classList.contains('disabled')
    ) {
      return null;
    }
    const properties = {};
    this.productForm.querySelectorAll('input').forEach(input => {
      if (input.getAttribute('name')?.includes('properties')) {
        const match = input.getAttribute('name').match(/properties\[(.*?)\]/);
        if (match) {
          properties[match[1]] = input.value;
        }
      }
    });

    let body = {
      id: this.v_id,
      quantity: 1,
      properties,
      sections: ThatWorks.cartElement.getSectionsToRender().map((section) => section.id),
    };

    console.log(body);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
    })
    .then(res => res.json())
    .then(res => {
      document.dispatchEvent(ThatWorks.pixelEvent.cart);
      ThatWorks.cartElement.renderContents(res);
    });
  }

  stickyShow(status) {
    if (!this.stickyAtcBtn) {
      return;
    }

    const parent = this.stickyAtcBtn.parentElement;
    parent.classList.toggle('sticky', status);
    const height = status ? parent.getBoundingClientRect().height : 0;
    if(window.innerWidth < 550) {
      document.querySelector('footer').style.marginBottom = `${height}px`;
    }
  }

  playVideo() {
    this.video.play()
    this.playButton.classList.add('is-hidden')

    this.video.addEventListener('ended', () => {
      this.playButton.classList.remove('is-hidden');
    }, { once: true });
  }

  pauseVideo() {
    this.video.pause()
    this.playButton.classList.remove('is-hidden')
  }

  initVideoObserver() {
    this.videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          this.video.pause();
          this.playButton.classList.remove('is-hidden');
        }
      });
    });
  
    this.videoObserver.observe(this.video);
  }
}
window.customElements.define('nikita-product', NikitaProduct);

window.ThatWorks.productElement = document.querySelector('nikita-product');

